export const fnOrValue = (value, ...args) => typeof value === 'function' ? value(...args) : value;
